//@flow
import type {
  Id,
  GrupamentosMedida,
  TipoDataBase,
  ModoApp,
  TipoIndice,
} from "./model";
import type { TipoAtivo } from "../state";

export const GRUPAMENTO_MEDIDAS_QUANTITATIVAS: GrupamentosMedida =
  "QUANTITATIVA";
export const GRUPAMENTO_MEDIDAS_QUALITATIVAS: GrupamentosMedida = "QUALITATIVA";
export const GRUPAMENTO_MEDIDAS_SERIES: GrupamentosMedida = "SERIES";
export const GRUPAMENTO_MEDIDAS_EMPRESAS: GrupamentosMedida = "EMPRESAS";
export const GRUPAMENTO_MEDIDAS_PERSONALIZADAS: GrupamentosMedida =
  "PERSONALIZADAS";

export const FORMATO_DATA_BANCO: string = "YYYYMMDD";
export const FORMATO_DATA_MES_ANO_COMPOSTA: string = "MMM/YYYY";
export const FORMATO_DATA_API: string = "YYYY-MM-DD";
export const FORMATO_DATA_HORA_EXIBICAO: string = "DD/MM/YYYY hh:mm";

export const ID_AJUSTE_DIAS_BANCO: Id = 1;
export const ID_AJUSTE_DIAS_NORMAL: Id = 0;
export const ID_AJUSTE_DIAS_JANELA: Id = 13;
export const ID_AJUSTE_DIAS_MENOS_1_TRIMESTRE: Id = 14;
export const ID_AJUSTE_DIAS_MENOS_2_TRIMESTRES: Id = 15;
export const ID_AJUSTE_DIAS_MENOS_3_TRIMESTRES: Id = 16;
export const ID_AJUSTE_DIAS_MENOS_1_ANO: Id = 17;
export const ID_AJUSTE_DIAS_MENOS_2_ANO: Id = 18;
export const ID_AJUSTE_DIAS_MENOS_3_ANO: Id = 19;
export const ID_AJUSTE_DIAS_MENOS_4_ANO: Id = 20;
export const ID_AJUSTE_DIAS_MENOS_5_ANO: Id = 21;

export const IDS_AJUSTE_DIAS_INDICADORES_FINANCEIROS = [
  ID_AJUSTE_DIAS_MENOS_1_TRIMESTRE,
  ID_AJUSTE_DIAS_MENOS_2_TRIMESTRES,
  ID_AJUSTE_DIAS_MENOS_3_TRIMESTRES,
  ID_AJUSTE_DIAS_MENOS_1_ANO,
  ID_AJUSTE_DIAS_MENOS_2_ANO,
  ID_AJUSTE_DIAS_MENOS_3_ANO,
  ID_AJUSTE_DIAS_MENOS_4_ANO,
  ID_AJUSTE_DIAS_MENOS_5_ANO,
];

export const MODO_EXIBICAO_RANKING = "RANKING";
export const COLUNAS_RANKING_COM_CASAS_DECIMAIS = [2, 3];
export const MODO_EXIBICAO_MEDIDA_COMPOSTA = "MEDIDA_COMPOSTA";
export const MODO_EXIBICAO_MEDIDA_QUALITATIVA = "MEDIDA_QUALITATIVA";

export const MODO_EXIBICAO_PONTUAL_MENSAL = "PONTUAL_MENSAL";
export const MODO_EXIBICAO_PONTUAL_MENSAL_DEFLATOR_CORRECAO =
  "PONTUAL_MENSAL_DEFLATOR_CORRECAO";
export const MODO_EXIBICAO_PONTUAL_MENSAL_ATIVO_COMPRADO =
  "PONTUAL_MENSAL_ATIVO_COMPRADO";
export const MODO_EXIBICAO_PONTUAL_MENSAL_COMPRADOR =
  "PONTUAL_MENSAL_COMPRADOR";
export const MODO_EXIBICAO_PONTUAL_MENSAL_CARTEIRA_EM_NIVEIS =
  "PONTUAL_MENSAL_CARTEIRA_EM_NIVEIS";
export const MODO_EXIBICAO_ACUMULACAO_DEFLATOR_COM_ANALISE_HORIZONTAL =
  "ACUMULACAO_DEFLATOR_COM_ANALISE_HORIZONTAL";

export const MODOS_EXIBICAO_INDICADORES_FINANCEIROS = [
  "BALANCO",
  "ACUMULACAO",
  "ACUMULACAO_PL",
  "ACUMULACAO_CAPITAL",
  "BALANCO_DEFLATOR",
  "ACUMULACAO_DEFLATOR",
  "ACUMULACAO_DEFLATOR_COM_ANALISE_HORIZONTAL",
];

export const ID_TIPO_DATA_REFERENCIA_REFERENCIA: Id = 1;
const ID_TIPO_DATA_REFERENCIA_UM_TRIMESTRE: Id = 2;
const ID_TIPO_DATA_REFERENCIA_DOIS_TRIMESTRE: Id = 3;
const ID_TIPO_DATA_REFERENCIA_TRES_TRIMESTRE: Id = 4;
const ID_TIPO_DATA_REFERENCIA_UM_ANO: Id = 5;
const ID_TIPO_DATA_REFERENCIA_DOIS_ANOS: Id = 6;
const ID_TIPO_DATA_REFERENCIA_TRES_ANOS: Id = 7;
const ID_TIPO_DATA_REFERENCIA_QUATRO_ANOS: Id = 8;
const ID_TIPO_DATA_REFERENCIA_CINCO_ANOS: Id = 9;

export const MAP_ID_AJUSTE_DIAS_TIPO_DATA_REFERENCIA_INDICADORES_FINANCEIROS = {
  [ID_AJUSTE_DIAS_BANCO]: ID_TIPO_DATA_REFERENCIA_REFERENCIA,
  [ID_AJUSTE_DIAS_MENOS_1_TRIMESTRE]: ID_TIPO_DATA_REFERENCIA_UM_TRIMESTRE,
  [ID_AJUSTE_DIAS_MENOS_2_TRIMESTRES]: ID_TIPO_DATA_REFERENCIA_DOIS_TRIMESTRE,
  [ID_AJUSTE_DIAS_MENOS_3_TRIMESTRES]: ID_TIPO_DATA_REFERENCIA_TRES_TRIMESTRE,
  [ID_AJUSTE_DIAS_MENOS_1_ANO]: ID_TIPO_DATA_REFERENCIA_UM_ANO,
  [ID_AJUSTE_DIAS_MENOS_2_ANO]: ID_TIPO_DATA_REFERENCIA_DOIS_ANOS,
  [ID_AJUSTE_DIAS_MENOS_3_ANO]: ID_TIPO_DATA_REFERENCIA_TRES_ANOS,
  [ID_AJUSTE_DIAS_MENOS_4_ANO]: ID_TIPO_DATA_REFERENCIA_QUATRO_ANOS,
  [ID_AJUSTE_DIAS_MENOS_5_ANO]: ID_TIPO_DATA_REFERENCIA_CINCO_ANOS,
};

export const ID_PERIODICIDADE_DIARIA: Id = 0;
export const ID_PERIODICIDADE_SEMANAL: Id = 1;
export const ID_PERIODICIDADE_MENSAL: Id = 2;

export const CHAVE_ENUM_GRUPAMENTO_MEDIDAS_EMPRESAS: string = "EMPRESAS";

export const ID_TIPO_JANELA_DIAS_UTEIS: Id = 0;
export const ID_TIPO_JANELA_MESES: Id = 1;
export const TAMANHO_DEFAULT_JANELA_TIPO_DIAS_UTEIS: number = 21;
export const TAMANHO_DEFAULT_JANELA_TIPO_MESES: number = 3;
export const QUANTIDADE_DEFAULT_JANELA: number = 4;
export const VALOR_DEFAULT_JANELA_MOVEL_VISIVEL: number = 1;
export const VALOR_DEFAULT_LAMBDA: number = 0.97;
export const VALOR_DEFAULT_HORIZONTE_DU: number = 21;
export const VALOR_DEFAULT_CONFIANCA: number = 95;
export const VALOR_DEFAULT_CORRETOR_MONETARIO: number = 0;
export const VALOR_DEFAULT_DEFLATOR: number = 0;
export const VALOR_DEFAULT_TOLERANCIA_DEMONSTRACAO_FINANCEIRA: number = 1;
export const VALOR_DEFAULT_COMPRADORES: number = 1;
export const VALOR_DEFAULT_LIMITE: number = 5;
export const VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_NUMERADOR: number = 21;
export const VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_VOLATILIDADE: number = 21;
export const VALOR_DEFAULT_BENCHMARK_QUANTITATIVA: string = "CDI";

export const ID_PERIODO_MES_FECHADO_1: Id = 1000;
export const ID_PERIODO_MES_FECHADO_2: Id = 1001;
export const ID_PERIODO_MES_FECHADO_3: Id = 1002;
export const ID_PERIODO_MES_FECHADO_4: Id = 1003;
export const ID_PERIODO_NO_DIA: Id = 48;
export const ID_PERIODO_NO_MES: Id = 3;
export const ID_PERIODO_INICIO_DA_SERIE: Id = 50;
export const ID_PERIODO_FINAL_DA_SERIE: Id = 51;
export const ID_PERIODO_NOS_ULTIMOS_4_MESES: Id = 54;
export const ID_PERIODO_ANO_A_ANO: Id = 60;
export const ID_PERIODO_DATAS_REFERENCIA: Id = 61;
export const ID_PERIODO_ANALISE_HORIZONTAL: Id = 62;
export const ID_PERIODO_DATA_ESPECIFICA_INDICADORES_MERCADO: Id = 63;
export const ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES: Id = 78;
export const ID_PERIODO_NO_BIMESTRE: Id = 7;
export const ID_PERIODO_NOS_ULTIMOS_10_DIAS_UTEIS: Id = 12;
export const ID_PERIODO_NOS_ULTIMOS_60_DIAS_UTEIS: Id = 18;
export const ID_PERIODO_NOS_ULTIMOS_60_DIAS_CORRIDOS: Id = 19;
export const ID_PERIODO_NOS_ULTIMOS_2_MESES: Id = 91;
export const ID_PERIODO_NOS_ULTIMOS_2_MESES_CORRIDOS: Id = 92;

export const PERIODOS_SEMANAIS = [
  ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES,
  ID_PERIODO_NO_BIMESTRE,
  ID_PERIODO_NOS_ULTIMOS_60_DIAS_UTEIS,
  ID_PERIODO_NOS_ULTIMOS_60_DIAS_CORRIDOS,
  ID_PERIODO_NOS_ULTIMOS_2_MESES,
  ID_PERIODO_NOS_ULTIMOS_2_MESES_CORRIDOS,
];

export const ID_PERIODO_JANELA: Id = 1;
export const ID_PERIODO_MES_A_MES: Id = 6;
export const ID_PERIODO_MES_A_MES_MENSAL: Id = 64;
export const ID_PERIODO_MES_ESPECIFICO: Id = 53;
export const ID_PERIODO_DATAS_ESPECIFICAS: Id = 0;
export const ID_PERIODO_DATAS_ESPECIFICAS_NAO_MENSAL: Id = 52;
export const ID_PERIODO_DATAS_ESPECIFICAS_SERIES: Id = 78;
export const ID_PERIODO_DIA_A_DIA: Id = 49;
export const ID_PERIODO_DATAS_REFERENCIA_INDICADORES_MERCADO: Id = 65;

export const ID_PERIODO_DATAS_INDICADORES_MERCADO: Id = 65;
export const ID_PERIODO_NO_DIA_INDICADORES_MERCADO: Id = 66;
export const ID_PERIODO_MENOS_5_DIAS_INDICADORES_MERCADO: Id = 67;
export const ID_PERIODO_MENOS_10_DIAS_INDICADORES_MERCADO: Id = 68;
export const ID_PERIODO_MENOS_15_DIAS_INDICADORES_MERCADO: Id = 69;
export const ID_PERIODO_MENOS_30_DIAS_INDICADORES_MERCADO: Id = 70;
export const ID_PERIODO_MENOS_60_DIAS_INDICADORES_MERCADO: Id = 71;
export const ID_PERIODO_MENOS_90_DIAS_INDICADORES_MERCADO: Id = 72;
export const ID_PERIODO_MENOS_120_DIAS_INDICADORES_MERCADO: Id = 73;
export const ID_PERIODO_MENOS_180_DIAS_INDICADORES_MERCADO: Id = 74;
export const ID_PERIODO_MENOS_360_DIAS_INDICADORES_MERCADO: Id = 75;

export const ID_PERIODO_ULTIMA_DIVULGACAO: Id = 76;
export const ID_PERIODO_ULTIMA_100_PORCENTO_ABERTA: Id = 77;

export const ID_CONFIGURACAO_RELATORIO_MEDIDA_NOME: Id = 1039;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_FIE: Id = 1222;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_COMPOSTA: Id = -5002;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO: Id = -5003;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_ANALISE_ESTILO_R2: Id = 1389;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE: Id = 2035;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE: Id = 2045;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE_EWMA: Id = 2782;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE_EWMA_ANUALIZADO: Id = 2783;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR: Id = 2042;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_BVAR: Id = 3384;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_MODIGLIANI: Id = 2014;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE_COMPLETO: Id = 3386;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_CORRELACAO: Id = 3381;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_ANALISE_ESTILO: Id = 3388;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_EXPLICACAO_RETORNO: Id = 3390;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_ALFA: Id = 2001;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_BETA: Id = 2003;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_DOWNSIDE_RISK: Id = 2784;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE_GENERALIZADO: Id = 2037;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_SORTINO: Id = 2038;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_TRACKING_ERROR: Id = 2039;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_TREYNOR: Id = 2040;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VALOR_ADICIONADO: Id = 2041;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR_CONDICIONAL: Id = 2043;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR_HISTORICO: Id = 2044;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_ABAIXO_BENCHMARK: Id = 2025;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_ACIMA_BENCHMARK: Id = 2026;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_RETORNO_NEGATIVO: Id = 2027;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_RETORNO_POSITIVO: Id = 2028;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_BENCHMARK_VOLATILIDADE: Id = 2024;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_ABAIXO_DO_BENCHMARK: Id = 2016;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_ACIMA_DO_BENCHMARK: Id = 2017;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_COM_RETORNO_NEGATIVO: Id = 2018;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_COM_RETORNO_POSITIVO: Id = 2019;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_CALMAR: Id = 2004;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_HABILIDADE_BRITO: Id = 2013;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_INFORMATION_RATIO: Id = 2142;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_SEMIVARIANCIA: Id = 2786;

export const ID_CONFIGURACAO_RELATORIO_MEDIDA_MAXIMO_DRAW_UP: Id = 2178;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_MAXIMO_DRAWDOWN: Id = 2055;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_ERRO_QUADRATICO_MEDIO: Id = 2787;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_COEFICIENTE_DE_ASSIMETRIA_SKEW: Id = 2788;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_COEFICIENTE_DE_CURTOSE: Id = 2789;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MINIMO: Id = 2054;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MEDIO: Id = 2034;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MAXIMO: Id = 2053;
export const ID_CONFIGURACAO_RELATORIO_MEDIDA_DATA_REFERENCIA_TRIMESTRE: Id = 4234;

export const TIPO_LISTA_PERIODO_INDICADORES_FINANCEIROS: string =
  "INDICADORES_FINANCEIROS";
export const TIPO_LISTA_PERIODO_DEFAULT: string = "DEFAULT";
export const TIPO_LISTA_PERIODO_PERIODO_DIARIO: string = "PERIODO_DIARIO";

export const ID_INDICADOR_FINANCEIRO_RECEITA_LIQUIDA: Id = 4100;
export const ID_INDICADOR_FINANCEIRO_EBIT_RESULTADO_ANTES_DO_RESULTADO_FINANCEIRO_E_DOS_TRIBUTOS: Id = 4100;

export const ID_INDICADOR_FINANCEIRO_CAPEX: Id = 4187;

export const ID_TIPO_REFERENCIA_EDITAVEL: Id = 1;

export const TIPO_ARQUIVO_CONFIGURACAO_RELATORIO: Id = 25;
export const TIPO_ARQUIVO_EMPRESA: Id = 21;
export const TIPO_ARQUIVO_SERIES: Id = 26;

export const TIPO_ATIVO_PGBL_VGBL: TipoAtivo = "PGBL_VGBL";
export const TIPO_ATIVO_FI: TipoAtivo = "FI";
export const TIPO_ATIVO_ACAO: TipoAtivo = "ACOES";
export const TIPO_ATIVO_INDICES: TipoAtivo = "INDICES";

export const ID_TIPO_INICIO_SERIE: Id = 50;
export const ID_TIPO_FINAL_SERIE: Id = 51;

export const ID_TIPO_CALCULO_PONTUAL: Id = 0;
export const ID_TIPO_CALCULO_VARIACAO_PERCENTUAL: Id = 1;

export const MODOS_EXIBICAO_INDICADORES_MERCADO = [
  "MERCADO",
  "BALANCO_MERCADO",
  "BALANCO_MERCADO_DEFLATOR",
  "ACUMULACAO_MERCADO",
  "ACOES_PONTUAL_DIARIO",
];

export const MODOS_EXIBICAO_CASAS_DECIMAIS_ESPECIFICAS_MODO_SERIES = {
  MERCADO: 2,
};

export const FORMATACAO_MOEDAS = [
  "MOEDA",
  "MOEDA_2_CASAS_DECIMAIS",
  "MOEDA_5_CASAS_DECIMAIS",
  "MOEDA_6_CASAS_DECIMAIS",
  "MOEDA_14_CASAS_DECIMAIS",
];

export const FORMATACAO_MOEDA_MILHARES: string = "MOEDA_EM_MILHARES";

export const MAP_ID_TIPO_QUANTIDADE_DIAS_REFERENCIA_POR_PERIODO = {
  [ID_PERIODO_NO_DIA_INDICADORES_MERCADO]: 1,
  [ID_PERIODO_MENOS_5_DIAS_INDICADORES_MERCADO]: 2,
  [ID_PERIODO_MENOS_10_DIAS_INDICADORES_MERCADO]: 3,
  [ID_PERIODO_MENOS_15_DIAS_INDICADORES_MERCADO]: 4,
  [ID_PERIODO_MENOS_30_DIAS_INDICADORES_MERCADO]: 5,
  [ID_PERIODO_MENOS_60_DIAS_INDICADORES_MERCADO]: 6,
  [ID_PERIODO_MENOS_90_DIAS_INDICADORES_MERCADO]: 7,
  [ID_PERIODO_MENOS_120_DIAS_INDICADORES_MERCADO]: 8,
  [ID_PERIODO_MENOS_180_DIAS_INDICADORES_MERCADO]: 9,
  [ID_PERIODO_MENOS_360_DIAS_INDICADORES_MERCADO]: 10,
};

export const ID_ESCALA_MOEDA_UNIDADES: Id = 0;
export const ID_ESCALA_MOEDA_MILHARES: Id = 1;
export const ID_ESCALA_MOEDA_MILHOES: Id = 2;
export const ID_ESCALA_MOEDA_BILHOES: Id = 3;

export const MULTIPLICADOR_ESCALA_MOEDA_MILHARES: number = 1000;
export const MULTIPLICADOR_ESCALA_MOEDA_MILHOES: number = 1000000;
export const MULTIPLICADOR_ESCALA_MOEDA_BILHOES: number = 1000000000;

export const CHAVES_ULTIMOS_QUATRO_MESES = [
  "periodos.mesFechado.0",
  "periodos.mesFechado.1",
  "periodos.mesFechado.2",
  "periodos.mesFechado.3",
];

export const INICIO_FAIXA_IDS_MESES_FECHADOS: Id = 3000;
export const FINAL_FAIXA_IDS_MESES_FECHADOS: Id = 4000;

export const TIPO_DATA_BASE_AUTOMATICA: TipoDataBase = "AUTOMATICA";
export const TIPO_DATA_BASE_FECHAMENTO: TipoDataBase = "FECHAMENTO";

export const POSICAO_MEDIDA_FIE_AUTOMATICA: number = 1;

export const ID_VALOR_BASE_DEFLATOR_ORIGINAL = 0;
export const ID_VALOR_BASE_DEFLATOR_CEM = 1;
export const ID_VALOR_BASE_DEFLATOR_OUTRO = 2;
export const ID_VALOR_BASE_DEFLATOR_ORIGINAL_ATIVO = 4;
export const ID_VALOR_BASE_DEFLATOR_NENHUM = 3;

export const ID_DATA_BASE_DEFLATOR_INICIO = 0;
export const ID_DATA_BASE_DEFLATOR_FINAL = 1;
export const ID_DATA_BASE_DEFLATOR_REFERENCIA = 2;
export const ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA = 3;
export const ID_DATA_BASE_DEFLATOR_NENHUM = 4;

export const PERIODOS_ESTENDIDOS = [
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_PERIODO_JANELA,
  ID_PERIODO_MES_A_MES,
  ID_PERIODO_MES_A_MES_MENSAL,
  ID_PERIODO_MES_ESPECIFICO,
  ID_PERIODO_DATAS_ESPECIFICAS,
  ID_PERIODO_DATAS_ESPECIFICAS_NAO_MENSAL,
  ID_PERIODO_DIA_A_DIA,
  ID_PERIODO_DATA_ESPECIFICA_INDICADORES_MERCADO,
  ID_PERIODO_DATAS_REFERENCIA_INDICADORES_MERCADO,
  ID_PERIODO_ANO_A_ANO,
  ID_PERIODO_DATAS_ESPECIFICAS,
  ID_PERIODO_DATAS_REFERENCIA,
  ID_PERIODO_INICIO_DA_SERIE,
  ID_PERIODO_FINAL_DA_SERIE,
];

export const TIPO_VISUALIZACAO_CARTEIRA_INDIVIDUAL = "INDIVIDUAL";

export const TIPO_RETORNO_NUMERADOR_MEDIO = "MEDIO";
export const TIPO_CALCULO_NUMERADOR_ARITMETICO = "ARITMETICO";
export const PERIODICIDADE_ESTATISTICA_ANUAL = "ANUAL";
export const TIPO_VOLATILIDADE_ATIVO = "ATIVO";
export const ESTIMACAO_VOLATILIDADE_AMOSTRA = "AMOSTRA";
export const TIPO_RETORNO_ESTATISTICA_DISCRETO = "DISCRETO";

export const ID_COLUNA_GRUPO_AXIS = "COLUNA_GRUPO";
export const ID_COLUNA_GRUPO_AGGRID = "ag-Grid-AutoColumn";

export const ID_TIPO_AJUSTE_PRECO_AJUSTADO: Id = 0;
export const ID_TIPO_AJUSTE_PRECO_NAO_AJUSTADO: Id = 1;
export const ID_TIPO_AJUSTE_PRECO_AJUSTADO_SEM_PROVENTOS_EM_DINHEIRO: Id = 2;
export const ID_TIPO_AJUSTE_PRECO_PADRAO: Id = ID_TIPO_AJUSTE_PRECO_AJUSTADO;

export const ID_FONTE_FIDC_QUANTUM: Id = 0;
export const ID_FONTE_FIDC_ANBIMA: Id = 1;
export const ID_FONTE_FIDC_PADRAO: Id = ID_FONTE_FIDC_QUANTUM;

export const MODO_APP_SERIES: ModoApp = "SERIES";
export const MODO_APP_NORMAL: ModoApp = "NORMAL";
export const MODO_APP_EXCEL: ModoApp = "EXCEL";

export const PATH_TELA_CONFIG_RELATORIO = "/static/configuracaorelatorio/";
export const PATH_TELA_CONFIG_SERIES = "/static/relatorioseries/";

export const FORMA_VISUALIZACAO_SERIES_POR_ATIVOS: Id = 0;
export const FORMA_VISUALIZACAO_SERIES_POR_DATAS: Id = 1;

export const IDENTIFICADOR_SERIE_NOME: Id = 0;
export const IDENTIFICADOR_SERIE_CNPJ: Id = 1;
export const IDENTIFICADOR_SERIE_CODIGO: Id = 2;

export const MAP_CODIGO_IDENTIFICADOR_ALIAS_COLUNA = {
  [IDENTIFICADOR_SERIE_NOME]: "NOME",
  [IDENTIFICADOR_SERIE_CNPJ]: "CNPJ",
  [IDENTIFICADOR_SERIE_CODIGO]: "CODIGO",
};

export const ID_OPCAO_PADRAO_CASAS_DECIMAIS: Id = -1;

export const ID_OPCAO_DEFLATOR_NENHUM: Id = 0;
export const ID_OPCAO_CORRETOR_MONETARIO_NENHUM: Id = 0;

export const OPCOES_DATA_BASE_DEFLATOR_MODO_NORMAL = [
  ID_DATA_BASE_DEFLATOR_REFERENCIA,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
  ID_DATA_BASE_DEFLATOR_NENHUM,
];

export const OPCOES_DATA_BASE_DEFLATOR_MODO_SERIES = [
  ID_DATA_BASE_DEFLATOR_INICIO,
  ID_DATA_BASE_DEFLATOR_FINAL,
  ID_DATA_BASE_DEFLATOR_REFERENCIA,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
  ID_DATA_BASE_DEFLATOR_NENHUM,
];

export const CHAVE_TIPO_INDICE_FTSE: TipoIndice = "FTSE";

export const MEDIDAS_SEM_CASAS_DECIMAIS = ["TEXTO", "DATA", "INTEIRO"];
export const ESCALA_MOEDA_PADRAO: any = null;
export const CASA_DECIMAL_PADRAO_NORMAL: number = 2;
export const CASA_DECIMAL_PADRAO_SERIES: number = 14;

export const DEFAULT_JANELA_MOVEL_POR_ID_MEDIDA = {
  [ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE]: 4,
  [ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE]: 4,
  [ID_CONFIGURACAO_RELATORIO_MEDIDA_ANALISE_ESTILO]: 4,
  [ID_CONFIGURACAO_RELATORIO_MEDIDA_EXPLICACAO_RETORNO]: 4,
};

export const ID_CATEGORIA_TUTORIAL_VIDEO_RELATORIO = "1";
export const ID_CATEGORIA_TUTORIAL_VIDEO_SERIES = "2";
export const MEDIDAS_COM_DEFAULT_JANELA_MOVEL_4 = [
  ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE_EWMA,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VOLATILIDADE_EWMA_ANUALIZADO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_BVAR,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_MODIGLIANI,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE_COMPLETO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_CORRELACAO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_ANALISE_ESTILO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_EXPLICACAO_RETORNO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_ALFA,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_BETA,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_DOWNSIDE_RISK,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_SHARPE_GENERALIZADO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_SORTINO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_TRACKING_ERROR,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_TREYNOR,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VALOR_ADICIONADO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR_CONDICIONAL,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_VAR_HISTORICO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_ABAIXO_BENCHMARK,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_ACIMA_BENCHMARK,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_RETORNO_NEGATIVO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_VEZES_RETORNO_POSITIVO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_PORCENTAGEM_BENCHMARK_VOLATILIDADE,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_ABAIXO_DO_BENCHMARK,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_ACIMA_DO_BENCHMARK,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_COM_RETORNO_NEGATIVO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_NUMERO_VEZES_COM_RETORNO_POSITIVO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_CALMAR,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_HABILIDADE_BRITO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_INFORMATION_RATIO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_SEMIVARIANCIA,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_MAXIMO_DRAW_UP,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_MAXIMO_DRAWDOWN,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_ERRO_QUADRATICO_MEDIO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_COEFICIENTE_DE_ASSIMETRIA_SKEW,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_COEFICIENTE_DE_CURTOSE,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MINIMO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MEDIO,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_RETORNO_MAXIMO,
];

export const MODOS_EXIBICAO_SERIES_COM_FLAG_ULTIMA_NEGOCIACAO = [
  "SERIES_COM_AJUSTE_E_FONTE",
  "SERIES_COM_AJUSTE_DEFLATOR_CORRECAO_FLAG_ULTIMA_NEGOCIACAO",
];

export const MEDIDAS_COM_TOOLTIP_JANELA_MOVEL = MEDIDAS_COM_DEFAULT_JANELA_MOVEL_4;

export const MAP_ORIGENS_REQUISICAO = {
  [MODO_APP_SERIES]: "TELA_SERIES",
  [MODO_APP_NORMAL]: "TELA_RELATORIO",
  [MODO_APP_EXCEL]: "TELA_EXCEL",
};
